export default __webpack_public_path__ + "ikano_background.jpg";